import React, { useRef } from 'react'
import { PaginationBar } from 'mailup-web-components'
import { useRecoilValue, useRecoilCallback } from 'recoil'
import { useIntl } from 'react-intl'
import { searchState } from '../recoil/state/search'
import { resultsState } from '../recoil/state/results'
import { searchMessagesCallback } from '../recoil/callbacks/callbacks'

const Pagination = () => {
  const intl = useIntl()
  const { pageNumber, pageSize } = useRecoilValue(searchState)
  const searchResults = useRecoilValue(resultsState)

  const fetchResults = useRecoilCallback(searchMessagesCallback, [])

  const { current: handleChangePageNumber } = useRef(pageNumber => {
    fetchResults({ pageNumber })
  })
  const { current: handleChangePageSize } = useRef(pageSize => {
    fetchResults({ pageSize, pageNumber: 1 })
  })

  return (
    <PaginationBar
      pageNumber={pageNumber}
      pageSize={pageSize}
      totalItems={searchResults.totalItems}
      strings={{
        of: intl.formatMessage({ id: 'Load.Pager.Of' }),
        label: intl.formatMessage({ id: 'Load.Pager.Items' })
      }}
      handleChangePage={handleChangePageNumber}
      handleChangePageSize={handleChangePageSize}
      data-mu-test='pagination__notification-msgs-list'
    />
  )
}

export default Pagination
